module.exports = __webpack_public_path__ + "img/arrow.03df704f.svg";